import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { AppMain, Sidebar, UPSHeader } from './components';
// import ResizeMixin from './mixin/ResizeHandler'
import { mapState, mapGetters, mapActions } from 'vuex';
import roles from '@/router/roles';
import request from '@/request';
import download from '@/request/download';
import { ElMessage } from 'element-plus';
import { logout } from '@/utils/msal.js';
export default {
  name: 'Layout',
  components: {
    AppMain: AppMain,
    Sidebar: Sidebar,
    UPSHeader: UPSHeader
  },
  // mixins: [ResizeMixin],
  data: function data() {
    var _this2 = this;
    var validPass = function validPass(rule, value, callback) {
      var regUppercase = /[A-Z]/.test(value);
      var regLowercase = /[a-z]/.test(value);
      var regNumber = /[0-9]/.test(value);
      var regValid = [regUppercase, regLowercase, regNumber].filter(function (v) {
        return !!v;
      }).length > 1;
      var lessLength = value.length >= 10;
      var moreLength = value.length <= 26;
      if (value && (!lessLength || !moreLength || !regValid)) {
        callback(new Error('密码长度在10-26个字符, 需包含大写字母,小写字母, 数字字符任选其三, 且不得包含您的姓名、用户名和邮箱'));
        return;
      }
      callback();
    };
    var validPass2 = function validPass2(rule, value, callback) {
      var regUppercase = /[A-Z]/.test(value);
      var regLowercase = /[a-z]/.test(value);
      var regNumber = /[0-9]/.test(value);
      var regValid = [regUppercase, regLowercase, regNumber].filter(function (v) {
        return !!v;
      }).length > 1;
      var lessLength = value.length >= 10;
      var moreLength = value.length <= 26;
      if (value && (!lessLength || !moreLength || !regValid)) {
        callback(new Error('密码长度在10-26个字符, 需包含大写字母,小写字母, 数字字符任选其三, 且不得包含您的姓名、用户名和邮箱'));
        return;
      }
      if (value !== _this2.modifyData.newPassword) {
        callback(new Error('两次输入密码不一致!'));
        return;
      }
      callback();
    };
    return {
      Eport: false,
      isAdmin: false,
      logoOutDialogStatus: false,
      modifyPswDialogStatus: false,
      exportDate: 2,
      exportType: '1',
      declarationTypes: [{
        label: '个人物品申报(B类)',
        value: 'B'
      }, {
        label: '低值货物快件(C类)',
        value: 'C'
      }, {
        label: '正式申报类货物(D类)',
        value: 'D'
      }],
      exportFormData: {
        declarationType: 'D',
        username: '所有客户',
        port: '所有口岸',
        slic: '所有SLIC',
        shipmentType: '-1',
        status: '-1',
        fromDate: '',
        toDate: '',
        sort: '1'
        // exportType: 0
      },
      exportExceptionType: '所有格式',
      dateRange: [],
      portList: [{
        declarationSlic: '',
        slicInfoList: '',
        upsFacilityName: '所有口岸',
        upsFacilitySlic: ''
      }],
      slicList: [],
      profileList: [],
      exceptionFileType: ['所有格式', 'EXCEL', 'XML'],
      typeList: [{
        label: '进口和出口',
        value: '-1'
      }, {
        label: '进口',
        value: '0'
      }, {
        label: '出口',
        value: '1'
      }],
      sortList: {
        1: [{
          label: '口岸',
          value: '1'
        }, {
          label: '客户账号',
          value: '2'
        }, {
          label: '预计取件时间-顺序',
          value: '3'
        }, {
          label: '预计取件时间-倒序',
          value: '4'
        }],
        2: [{
          label: '创建异常时间-顺序',
          value: '1'
        }, {
          label: '创建异常时间-倒序',
          value: '2'
        }]
      },
      /**
       * status.1 是导出报关单 status.2是导出清关异常
         * (0, “草稿”), UNPROCESSED(1, “未处理”), PROCESSED(2, “已审结未完成”), DONE(3, “已完成”), RETURN(4, “退单”), DELETED(5, “删除”)
         */
      statusList: {
        1: [{
          label: '所有状态',
          value: '-1'
        }, {
          label: '草稿',
          value: '0'
        }, {
          label: '未处理',
          value: '1'
        }, {
          label: '已审结未完成',
          value: '2'
        }, {
          label: '已完成',
          value: '3'
        }, {
          label: '单证异常待补充',
          value: '4'
        }, {
          label: '退单未完成',
          value: '10'
        }, {
          label: '退单未提交',
          value: '11'
        }, {
          label: '删除',
          value: '5'
        }],
        2: [{
          label: '所有状态',
          value: '-1'
        }, {
          label: '待处理',
          value: '1'
        }, {
          label: '已通知客户',
          value: '2'
        }, {
          label: '待客户确认',
          value: '3'
        }, {
          label: '待审核',
          value: '4'
        }, {
          label: '已审结',
          value: '6'
        }, {
          label: '作废',
          value: '7'
        }]
      },
      exportRules: {
        portCode: [{
          required: true,
          message: '请选择口岸',
          trigger: 'change'
        }]
      },
      modifyData: {
        'username': undefined,
        'oldPassword': undefined,
        'newPassword': undefined,
        'confirmNewPassword': undefined
      },
      modifyRules: {
        username: [{
          required: true,
          message: '用户名不能为空',
          trigger: 'blur'
        }],
        oldPassword: [{
          required: true,
          message: '请输入密码',
          trigger: ['blur']
        }, {
          validator: validPass,
          trigger: ['blur']
        }],
        newPassword: [{
          required: true,
          message: '请输入密码',
          trigger: ['blur']
        }, {
          validator: validPass,
          trigger: ['blur']
        }],
        confirmNewPassword: [{
          required: true,
          message: '请输入密码',
          trigger: ['blur']
        }, {
          validator: validPass2,
          trigger: ['blur']
        }]
      },
      passwordType: 'password',
      password1Type: 'password',
      password2Type: 'password',
      timer: null,
      selectDate: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.settings.fixedHeader;
    }
  })), mapGetters({
    userinfo: 'user/userinfo',
    role: 'user/role',
    requestsBeforeLogout: 'user/requestsBeforeLogout'
  })),
  created: function created() {
    this.isAdmin = this.role === roles.roleAdmin;
    // console.log(this.role, '看一下角色是什么')
    this.modifyData.username = this.userinfo.userName;
    if (this.userinfo.isLocked) {
      this.$router.push({
        path: '/customers-center/bind'
      });
      // this.$route.meta.activeMenu = '/customers-center/account'
      this.$bus.$emit('updateActiveMenu', '/customers-center/account');
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    LOGOUT: 'user/LOGOUT'
  })), {}, {
    onCalendarChange: function onCalendarChange(val) {
      this.selectDate = val;
    },
    disabledDate: function disabledDate(time) {
      if (time.getTime() > Date.now()) return true;
      if (!this.selectDate.length) return false;
      var sd = this.selectDate[0];
      var days = (time.getTime() - sd.getTime()) / (1000 * 60 * 60 * 24);
      return days > 180 || days < -180;
    },
    dateChange: function dateChange(val) {
      if (!val) {
        this.selectDate = [];
        return;
      }
      var beginDate = new Date(val[0]);
      var endDate = new Date(val[1]);
      var days = (endDate - beginDate) / (1000 * 60 * 60 * 24);
      if (days > 365) {
        this.dateRange = [];
        ElMessage({
          message: '时间跨度不可以超过一年，请重新选择',
          type: 'error',
          grouping: true
        });
        return;
      }
    },
    exportCancel: function exportCancel() {
      this.Eport = false;
      this.dateRange = [];
    },
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    clearData: function clearData() {
      this.Eport = false;
      this.exportFormData = {
        username: '所有客户',
        port: '所有口岸',
        slic: '所有SLIC',
        shipmentType: '-1',
        status: '-1',
        fromDate: '',
        toDate: '',
        sort: '1',
        declarationType: 'D'
        // exportType: 0
      };
      this.exportType = '1';
    },
    getProfileList: function getProfileList() {
      var _this3 = this;
      var _this = this;
      request({
        url: '/api/v1/admin/customers',
        method: 'GET',
        params: {
          declarationType: this.exportFormData.declarationType
        }
      }).then(function (res) {
        var bean = {
          city: undefined,
          companyName: undefined,
          portCode: undefined,
          slicCode: undefined,
          username: '所有客户'
        };
        _this3.profileList = [];
        _this.profileList.push(bean);
        _this.profileList = _this.profileList.concat(res.records);
      });
    },
    getPortListData: function getPortListData() {
      var _this4 = this;
      request({
        url: '/api/v1/port/slic-info',
        method: 'GET'
      }).then(function (res) {
        _this4.portList = [{
          declarationSlic: '所有口岸',
          slicInfoList: '',
          upsFacilityName: '所有口岸',
          upsFacilitySlic: ''
        }];
        _this4.portList = _this4.portList.concat(res);
        _this4.slicList = [];
        var slicBean = {
          createBy: '',
          createTime: null,
          declarationSlic: '',
          deleted: undefined,
          id: null,
          updateBy: '',
          updateTime: null,
          upsFacilityName: '所有SLIC',
          upsFacilitySlic: ''
        };
        _this4.slicList.push(slicBean);
        _this4.slicList = _this4.slicList.concat(res[0].slicInfoList);
      });
    },
    onTypeChange: function onTypeChange() {
      this.exportFormData.username = '所有客户';
      this.exportFormData.port = '所有口岸';
      this.getProfileList();
    },
    changePort: function changePort(value) {
      var _this5 = this;
      if (!value) {
        this.exportFormData = _objectSpread(_objectSpread({}, this.exportFormData), {}, {
          port: '所有口岸'
        });
      }
      this.portList.forEach(function (item) {
        if (value === item.declarationSlic) {
          _this5.slicList.splice(1, _this5.slicList.length);
          _this5.slicList = _this5.slicList.concat(item.slicInfoList);
        }
      });
    },
    changeDatePick: function changeDatePick(value) {
      // this.slicList = value.slicInfoList
    },
    // typeChange(value) {
    //   console.log('typeChange=>value:', value)
    //   this.exportFormData.exportType = value
    // },
    showDialog: function showDialog(value) {
      if (this.isAdmin) {
        this.getPortListData();
        this.getProfileList();
      }
      this.Eport = value;
    },
    showLogoutDialog: function showLogoutDialog(value) {
      this.logoOutDialogStatus = true;
    },
    sortChange: function sortChange(value) {
      console.log('value:', value);
    },
    submitForm: function submitForm(formData) {
      // exportType 为1的时候是导出报关 2的时候是导出异常
      if (this.exportType === '1') {
        if (this.exportDate === 2) {
          this.exportFormData.fromDate = this.dateRange && this.dateRange.length ? this.dateRange[0] : '';
          this.exportFormData.toDate = this.dateRange && this.dateRange.length ? this.dateRange[1] : '';
        }
        if (this.exportFormData.slic === '所有SLIC') {
          this.exportFormData.slic = '';
        }
        if (this.exportFormData.port === '所有口岸') {
          this.exportFormData.port = '';
        }
        if (this.exportFormData.username === '所有客户') {
          this.exportFormData.username = '';
        }
        if (this.dateRange.length === 0) {
          ElMessage({
            message: '请选择自定义日期',
            type: 'error',
            grouping: true
          });
          return;
        }
        this.exportOrder();
        // this.$refs[formData].validate((valid) => {
        //   if (valid) {
        //   } else {
        //     return false
        //   }
        // })
      } else {
        if (this.dateRange.length === 0) {
          ElMessage({
            message: '请选择自定义日期',
            type: 'error',
            grouping: true
          });
          return;
        }
        this.exportException();
      }
    },
    exportOrder: function exportOrder() {
      var _this6 = this;
      if (this.exportFormData.status === '-1') {
        this.exportFormData.status = '';
      }
      if (this.exportFormData.shipmentType === '-1') {
        this.exportFormData.shipmentType = '';
      }
      download({
        url: '/api/v1/declarations/batch-export',
        method: 'POST',
        data: _objectSpread({}, this.exportFormData),
        responseType: 'arraybuffer'
      }, {
        exportTypr: '导出报表',
        fileType: '.xlsx',
        declarationType: this.exportFormData.declarationType
      }).then(function (res) {
        if (res.status === 200) {
          _this6.Eport = false;
        }
        if (res.status === 500) {
          ElMessage({
            message: res.message,
            iconClass: 'el-icon-warning-outline',
            grouping: true
          });
        }
        _this6.dateRange = [];
      });
    },
    exportException: function exportException() {
      var _this7 = this;
      var copyData = JSON.parse(JSON.stringify(this.exportFormData));
      if (this.exportDate === 2) {
        copyData.fromDate = this.dateRange && this.dateRange.length ? this.dateRange[0] : '';
        copyData.toDate = this.dateRange && this.dateRange.length ? this.dateRange[1] : '';
      }
      var matchType = {
        'EXCEL': {
          code: '01',
          suffix: '.xlsx'
        },
        'XML': {
          code: '02',
          suffix: '.xml'
        },
        '所有格式': {
          code: '03'
        }
      };
      copyData['exportFormat'] = matchType[this.exportExceptionType].code;
      delete copyData.slic;
      delete copyData.username;
      console.log(copyData, 'submit data');
      download({
        url: '/api/v1/clearance/batch-export',
        method: 'POST',
        data: copyData,
        responseType: 'arraybuffer'
      }, {
        exportTypr: '导出报表',
        fileType: matchType[this.exportExceptionType].suffix,
        fileName: "clearance-".concat(new Date().format('MMdd-hhmm'))
      }).then(function (res) {
        if (res.status === 200) {
          _this7.Eport = false;
        }
        _this7.dateRange = [];
      });
    },
    logoOut: function logoOut() {
      var _this8 = this;
      this.logoOutDialogStatus = false;
      if (this.requestsBeforeLogout) {
        request({
          url: this.requestsBeforeLogout.url,
          method: this.requestsBeforeLogout.method,
          params: this.requestsBeforeLogout.params
        }).then(function (res) {
          _this8.realLogout();
        });
      } else {
        this.realLogout();
      }
    },
    realLogout: function realLogout() {
      var _this9 = this;
      // 登出
      this.LOGOUT().then(function () {
        var url;
        var isClientCLogout;
        if (_this9.role === roles.roleCustomer) {
          url = '/login-c';
          isClientCLogout = true;
          _this9.$router.push({
            path: url,
            query: {
              isClientCLogout: isClientCLogout
            }
          });
        } else {
          // url = '/login-b'
          logout();
        }
        // this.$router.push({ path: url, query: { isClientCLogout }})
      });
    },
    changeType: function changeType(field) {
      if (this[field] === 'text') {
        this[field] = 'password';
      } else {
        this[field] = 'text';
      }
    },
    modifyPsw: function modifyPsw(value) {
      this.modifyPswDialogStatus = true;
    },
    confirmModifyPsw: function confirmModifyPsw() {
      var _this0 = this;
      this.$refs.modifyData.validate(function (valid) {
        if (valid) {
          request({
            url: '/api/v1/account/password/change',
            method: 'POST',
            data: _objectSpread({}, _this0.modifyData)
          }).then(function (res) {
            ElMessage({
              message: '修改成功',
              grouping: true
            });
            _this0.modifyPswDialogStatus = false;
            _this0.logoOut();
          });
        } else {
          return false;
        }
      });
    },
    changeRadio: function changeRadio(sort) {
      this.exportFormData.port = '所有口岸';
      this.exportFormData.slic = '所有SLIC';
      this.exportFormData.username = '所有客户';
      this.exportFormData.shipmentType = '-1';
      this.exportFormData.status = '-1';
      this.exportFormData.fromDate = '';
      this.exportFormData.toDate = '';
      this.exportFormData.sort = sort;
      this.dateRange = [];
    }
  })
};